import { useRef } from 'react';
import { useSignalRHub, type ConnectionStatus } from '@/realtime/useSignalRHub';

// Trade Blotter live hub (/hubs/trade-blotter). Server pushes OnBlotterChanged(signature);
// the first signature is a baseline (no reload), later changes trigger onChanged.
// Mirrors initLiveRefresh / onBlotterSignature in the legacy index.js.
export function useTradeBlotterLive({ enabled, onChanged }: { enabled: boolean; onChanged: () => void }): { status: ConnectionStatus } {
  const lastSig = useRef<string | null>(null);
  const onChangedRef = useRef(onChanged);
  onChangedRef.current = onChanged;

  const { status } = useSignalRHub({
    url: '/hubs/trade-blotter',
    enabled,
    on: {
      OnBlotterChanged: (signature) => {
        const sig = signature as string;
        if (lastSig.current === null) {
          lastSig.current = sig;
          return;
        }
        if (sig === lastSig.current) return;
        lastSig.current = sig;
        onChangedRef.current();
      },
    },
    onConnected: (conn) => {
      void conn.invoke('Subscribe').catch(() => {});
    },
  });

  return { status };
}
